import "./App.css";

import { Switch, Route, Redirect, BrowserRouter as Router,  BrowserRouter, Routes } from "react-router-dom";
import { createBrowserHistory  } from "history";
import Login from "./layout/login";
import Main from "./layout/main";
import Signup from "./layout/signup";

import initListen from "./utils/WebIMListen";
import Loading from "./components/common/loading";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Provider, UIKitProvider, eventHandler, useSDK } from "agora-chat-uikit";
import { handleError } from "./handleError";
import customIcon from "./assets/custom.png";
import { AGORA_CHAT_APP_KEY } from "./utils/constant";

const history = createBrowserHistory();

const AuthorizedComponent = (props) => {
	const Component = props.component;
	const webimAuth = sessionStorage.getItem("webim_auth");

	return webimAuth ? (
		<Switch>
			<Redirect to="/chat/main" render={(props) => <Component {...props} />} />
		</Switch>
	) : (
		<Redirect to="/" />
	);
};

function App() {
	const isFetching = useSelector((state) => state?.isFetching) || false;
	// close Chat and RTC log
	const state = useSelector((state) => state);
	const { AgoraRTC, ChatSDK } = useSDK();
	ChatSDK.logger.disableAll();
	AgoraRTC.setLogLevel(4);
	useEffect(() => {
		initListen();
		eventHandler.addEventHandler("messageEvent", {
			onError: handleError,
			recallMessage: {
				error: () => {
					console.log("recallMessage error");
				}
			},
			sendMessage: {
				error: () => {
					console.log("sendMessage error");
				}
			},
			modifyMessage: {
				error: () => {
					console.log("modifyMessage error");
				}
			}
		})
	}, []);
	return (
		<div className="App">
			<Loading show={isFetching} />
			<UIKitProvider
				// onError={handleError}
				initConfig={{
					appKey: AGORA_CHAT_APP_KEY,
					useUserInfo: true,
					translationTargetLanguage: state?.targetLanguage
				}}
			// reactionConfig={{
			// 	path: '/assets/',
			// 	map: {
			// 		'emoji_1': <img src={customIcon} alt={'emoji_1'} />,
			// 		'emoji_2': <img src={customIcon} alt={'emoji_2'} />,
			// 		'emoji_3': <img src={customIcon} alt={'emoji_3'} />,
			// 		'emoji_4': <img src={customIcon} alt={'emoji_4'} />
			// 	}
			// }}
			>
				<Router history={history}>
					<Switch>
						<Route exact path="/chat/login" component={Login} />
						<Route exact path="/chat/main" component={Main} />

						<Route exact path="/chat/signup" component={Signup} />
						<Route
							path="/"
							render={() => (
								<AuthorizedComponent token={"11"} component={Main} />
							)}
						/>
					</Switch>
				</Router>
			</UIKitProvider>
		</div>
	);
}

export default App;
